import { render, staticRenderFns } from "./Audience.vue?vue&type=template&id=ca67a720&scoped=true"
import script from "./Audience.vue?vue&type=script&lang=js"
export * from "./Audience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca67a720",
  null
  
)

export default component.exports